import * as React from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"

import { AppStore } from "../../store"
import OldUIContext from "../../olduicontext"
import { IOldUIContext } from "../../global"

import * as AuditsSlice from "./slice"
import { ICheckListViewActions, ICheckListViewData } from "."
import CheckListView from "./components/CheckListView"

interface StartProps extends AuditsSlice.IInitializeCheckListView {
    contextMenuActions: ICheckListViewActions
}

interface OldUIInit {
    startCheckListView: (elementSelector: string, props: StartProps) => void
    reloadData: (props: ICheckListViewData) => void
    expandTopic: (id: string) => void
    collapseTopic: (id: string) => void
}

function init(store: AppStore, oldUIContext: IOldUIContext): OldUIInit {
    const startCheckListView = (
        elementSelector: string,
        props: StartProps,
    ): void => {
        // we cannot pass down an element, because this is called from an iframe custom view
        // but the container we should load into is not within an iframe
        const element = document.querySelector(elementSelector)
        if (!element) {
            // target container doesn't exist, skip initialization
            return
        }

        const root = createRoot(element)
        root.render(
            <Provider store={store}>
                <OldUIContext.Provider value={oldUIContext}>
                    <CheckListView {...props} />
                </OldUIContext.Provider>
            </Provider>,
        )
    }

    const reloadData = (props: ICheckListViewData): void => {
        store.dispatch(AuditsSlice.loadData(props))
    }

    const expandTopic = (id: string): void => {
        store.dispatch(AuditsSlice.expand(id))
    }

    const collapseTopic = (id: string): void => {
        store.dispatch(AuditsSlice.collapse(id))
    }

    return {
        startCheckListView,
        reloadData,
        expandTopic,
        collapseTopic,
    }
}

export default init
